import clsx from "clsx";

// Interface
interface IconProps {
	classes?: string;
	sx?: object;
	disabled?: boolean;
}

// MUI
import { SvgIcon } from "@mui/material";

export default function ReviewedIcon(props: Readonly<IconProps>) {
	const { classes = "", sx = null } = props;

	return (
		<SvgIcon
			inheritViewBox
			className={clsx({
				[classes]: Boolean(classes),
			})}
			sx={{ fill: "#22ad5c", ...sx }}
		>
			<path d="M4.13,8.11L1.35,5.32c-.31-.31-.8-.31-1.11,0s-.31,.8,0,1.11l3.33,3.33c.31,.31,.81,.31,1.12,0L13.12,1.35c.31-.31,.31-.8,0-1.11s-.8-.31-1.11,0l-7.87,7.87Z" />
		</SvgIcon>
	);
}
